import { apiClient } from './apiClient';
import type {
  QARun,
  QACheckResult,
  QAContentCheckFilters,
} from '../types/qaContentChecks';

class QAContentCheckService {
  async getRuns(
    tenantId: string,
    filters: QAContentCheckFilters,
    limit = 50
  ): Promise<QARun[]> {
    const params: Record<string, string | number> = {
      tenant_id: tenantId,
      limit,
    };

    if (filters.status !== 'all') {
      params.status = filters.status;
    }
    if (filters.dateFrom) {
      params.date_from = filters.dateFrom;
    }
    if (filters.dateTo) {
      params.date_to = filters.dateTo;
    }

    const { data } = await apiClient.get<QARun[]>('/qa/runs', { params });
    return data ?? [];
  }

  async getCheckResults(runId: string): Promise<QACheckResult[]> {
    const { data } = await apiClient.get<QACheckResult[]>(
      `/qa/runs/${runId}/results`
    );
    return data ?? [];
  }
}

export const qaContentCheckService = new QAContentCheckService();
